import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SuperadminLogin.css';
import api from '../api';

function SuperadminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/api/auth/superadmin-login', { email, password });
      const data = res && res.data ? res.data : null;
      if (data && data.success && data.token) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('role', 'superadmin');
        navigate('/superadmin/approval');
      } else {
        alert((data && data.message) || 'Login failed');
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) alert(err.response.data.message);
      else alert('Error: ' + (err.message || 'Request failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card container">
        <h2>Super-Admin Login</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="super-email">Email</label>
            <input id="super-email" className="fancy-input" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" type="email" required />
          </div>
          <div className="form-group">
            <label htmlFor="super-pass">Password</label>
            <input id="super-pass" className="fancy-input" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" type="password" required />
          </div>
          <button type="submit">Login</button>
        </form>
        {/* <div className="auth-footer">Already have account? <a href="/superadmin/login">Sign in</a></div> */}
      </div>
      
      {loading && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div className="loading">
            <div className="spinner"></div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SuperadminLogin;
